import { NoOrgState } from '@pwa/components/auth/no-org-state';
import { orgQueries } from '@pwa/queries/org/org';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/')({
	loader: async ({ context }) => {
		const orgList = await context.queryClient.fetchQuery(orgQueries.list());
		if (orgList.organizations.length === 0) {
			return;
		}

		const selectedOrg = orgList.organizations[0];
		throw redirect({
			to: '/org/$orgId',
			params: { orgId: selectedOrg.id },
			replace: true,
		});
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <NoOrgState />;
}
